/**
 * AndroidBackProvider
 * 
 * Provider that handles Android system Back button globally.
 * Must be rendered inside BrowserRouter to access routing context.
 * 
 * On root screens (/, /catalog, /profile, etc.) → exits the app
 * On other screens → navigates back in history
 */

import { useAndroidBackHandler } from '@/hooks/useAndroidBackHandler';

interface AndroidBackProviderProps {
  children: React.ReactNode;
}

export function AndroidBackProvider({ children }: AndroidBackProviderProps) {
  useAndroidBackHandler();
  return <>{children}</>;
}
